import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-main-footer',
    templateUrl: './app-main-footer.component.html',
    styleUrls: ['./app-main-footer.component.scss'],
    standalone: false
})
export class AppMainFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
